@if (visible) {
  <div class="banner" role="status">
    <div class="banner-content">
      <div class="banner-text">
        <i class="fa-solid fa-party-horn banner-icon" aria-hidden="true"></i>
        <p>
          <span class="banner-bold">Already landed something?</span>
          <span> Tell us about it.</span>
        </p>
      </div>
      <button class="banner-cta" (click)="onShare()">
        Share your new job or internship
        <i class="fa-light fa-arrow-right" aria-hidden="true"></i>
      </button>
    </div>
    <button
      class="banner-close"
      (click)="onDismiss()"
      aria-label="Dismiss banner"
    >
      <i class="fa-regular fa-xmark" aria-hidden="true"></i>
    </button>
  </div>
}
